/* import { createStore, applyMiddleware } from "redux"; */
import createSagaMiddleware from "redux-saga";
import reducer from "Redux/reducers";
import sagas from "Redux/sagas";
/* import { composeWithDevTools } from '@redux-devtools/extension' */
import { configureStore } from "@reduxjs/toolkit";
const loadState = () => {
    try {
        const serializedState = localStorage.getItem('general');
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return undefined;
    }
};

const saveState = (state) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem('general', serializedState);
    } catch {
        // ignore write errors
    }
};

// create the saga middleware
const sagaMiddleware = createSagaMiddleware();

const persistedState = loadState();

// mount it on the Store
const store = configureStore({
    reducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false,  immutableCheck: false }).concat(sagaMiddleware),
    preloadedState: persistedState,
    /* devTools: process.env.STACK !== 'production' */
});

store.subscribe(() => {
    saveState({
        generalRedux: store.getState().generalRedux
    });
});

sagaMiddleware.run(sagas);

export default store;